import { type ReactNode } from "react"

import { Box, Button, IconButton } from "@mui/material"
import { Link } from "react-router-dom"

export interface ButtonBarItem {
    label?: string, 
    onClick?: React.MouseEventHandler<HTMLButtonElement>, 
    link?: string, 
    state?: any,
    color?: "inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning",
    icon?: ReactNode,
    size?: "small" | "medium" | "large",
    disabled?: boolean,
    loading?: boolean,
}
interface ButtonBarProps { buttons: ButtonBarItem[]}

export const ButtonBar = (props:ButtonBarProps) => {

    const buttons =  props.buttons.map( (button, key) => {

        const buttonContent = button.icon?
        (
            <IconButton
                sx={{
                    ml:1,
                    backgroundColor: "secondary.main",
                    color: 'secondary.contrastText',
                    "&:hover": {
                      backgroundColor: "secondary.dark",
                    },
                  }
                } 
                size={button.size??"small"}
                key={key} 
                color={button.color} 
                onClick={button.onClick}
                loading={button.loading}
                disabled={button.disabled}>
                    {button.icon}
            </IconButton>
        ):
        (
            <Button 
                sx={{ml:1}} 
                key={key} 
                color={button.color} 
                variant='contained'
                size={button.size??"small"}
                onClick={button.onClick}
                loading={button.loading}
                disabled={button.disabled}>
                    {button.label}
            </Button>
        )

        return (button.link)?
                <Link 
                    key={key} 
                    to={button.link} 
                    style={{textDecoration:'none'}}
                    state={button.state}>
                        {buttonContent}
                </Link>:
                buttonContent
    })


    return (
        <Box sx={{
            display:'flex',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'right'
        }}>
            {buttons}
        </Box>
    )
}